import { render, staticRenderFns } from "./del1.vue?vue&type=template&id=042ab82c&scoped=true&"
import script from "./del1.vue?vue&type=script&lang=js&"
export * from "./del1.vue?vue&type=script&lang=js&"
import style0 from "./del1.vue?vue&type=style&index=0&id=042ab82c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042ab82c",
  null
  
)

export default component.exports